/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../ui-elements/spinner/spinner.component.ngfactory';
import * as import2 from '../../ui-elements/spinner/spinner.component';
import * as import3 from '../../html-utils/css-var.directive';
import * as import4 from '@angular/common';
import * as import5 from './apple-pay-button.component';
import * as import6 from '../../payment/payment.model';
const styles_ApplePayButtonComponent:any[] = ([] as any[]);
export const RenderType_ApplePayButtonComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ApplePayButtonComponent,
  data: {}
}
);
function View_ApplePayButtonComponent_1(l:any):import0.ɵViewDefinition {
      return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'apple-pay-button'
      ]
  ],(null as any),(null as any),(null as any),(null as any),(null as any)))],(null as any),(null as any));
}
function View_ApplePayButtonComponent_2(l:any):import0.ɵViewDefinition {
      return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'id',
        'tyro-apple-pay-form-holder'
      ]
  ],(null as any),(null as any),(null as any),(null as any),(null as any)))],(null as any),(null as any));
}
function View_ApplePayButtonComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-spinner',[[
        'class',
        'face-spinner'
      ]
    ],(null as any),(null as any),(null as any),import1.View_SpinnerComponent_0,import1.RenderType_SpinnerComponent)),
    import0.ɵdid(49152,(null as any),0,import2.SpinnerComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export function View_ApplePayButtonComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'face'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      import0.ɵdid(671744,(null as any),0,import3.CssVarDirective,[import0.ElementRef],{cssVars: [
        0,
        'cssVars'
      ]
    },(null as any)),
    import0.ɵpod([
      '--apple-pay-button-type',
      '--apple-pay-button-style'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ApplePayButtonComponent_1)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ApplePayButtonComponent_2)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ApplePayButtonComponent_3)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import5.ApplePayButtonComponent = v.component;
    const currVal_0:any = ck(v,2,0,co.type,co.style);
    ck(v,1,0,currVal_0);
    const currVal_1:any = co.isPassive;
    ck(v,5,0,currVal_1);
    const currVal_2:boolean = (!co.isPassive && (co.paymentModel.paymentProvider === co.IntegratedPaymentProvider.TYRO));
    ck(v,8,0,currVal_2);
    const currVal_3:any = (co.showSpinner || co.showTyroSpinner);
    ck(v,11,0,currVal_3);
  },(null as any));
}
function View_ApplePayButtonComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-apple-pay-button',([] as any[]),[
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_ApplePayButtonComponent_0,RenderType_ApplePayButtonComponent)),
    import0.ɵdid(4964352,(null as any),0,import5.ApplePayButtonComponent,[
      import0.ElementRef,
      import6.PaymentModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    const currVal_1:any = import0.ɵnov(v,1).button;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
export const ApplePayButtonComponentNgFactory:import0.ComponentFactory<import5.ApplePayButtonComponent> = import0.ɵccf('woa-apple-pay-button',import5.ApplePayButtonComponent,View_ApplePayButtonComponent_Host_0,{
  passiveOnly: 'passiveOnly',
  type: 'type',
  disabled: 'disabled',
  showSpinner: 'showSpinner'
}
,{
  pay: 'pay',
  paymentStarted: 'paymentStarted',
  paymentComplete: 'paymentComplete',
  paymentFailed: 'paymentFailed',
  paymentCancelled: 'paymentCancelled'
}
,([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/buttons/apple-pay-button/apple-pay-button.component.ngfactory.ts